export default "__VITE_ASSET__DiyJGieN__"